var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "70%" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { attrs: { "min-width": "70%" } },
        [
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ma-1 mr-n2",
                  attrs: { icon: "", color: "red" },
                  on: { click: _vm.onClose },
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "py-0" },
            [
              _c("v-text-field", {
                attrs: {
                  type: "number",
                  outlined: "",
                  dense: "",
                  rules: [_vm.rules.value],
                },
                on: {
                  input: function ($event) {
                    return _vm.onInput(0)
                  },
                },
                model: {
                  value: _vm.min[0],
                  callback: function ($$v) {
                    _vm.$set(_vm.min, 0, $$v)
                  },
                  expression: "min[0]",
                },
              }),
              _c("v-card", { staticClass: "ma-1", attrs: { elevation: "0" } }, [
                _vm._v("."),
              ]),
              _c("v-text-field", {
                attrs: {
                  type: "number",
                  outlined: "",
                  dense: "",
                  rules: [_vm.rules.value],
                },
                on: {
                  input: function ($event) {
                    return _vm.onInput(0)
                  },
                },
                model: {
                  value: _vm.min[1],
                  callback: function ($$v) {
                    _vm.$set(_vm.min, 1, $$v)
                  },
                  expression: "min[1]",
                },
              }),
              _c("v-card", { staticClass: "ma-1", attrs: { elevation: "0" } }, [
                _vm._v("."),
              ]),
              _c("v-text-field", {
                attrs: {
                  type: "number",
                  outlined: "",
                  dense: "",
                  rules: [_vm.rules.value],
                },
                on: {
                  input: function ($event) {
                    return _vm.onInput(0)
                  },
                },
                model: {
                  value: _vm.min[2],
                  callback: function ($$v) {
                    _vm.$set(_vm.min, 2, $$v)
                  },
                  expression: "min[2]",
                },
              }),
              _c(
                "v-card",
                { staticClass: "ma-3 pb-6", attrs: { elevation: "0" } },
                [_vm._v("-")]
              ),
              _c("v-text-field", {
                attrs: {
                  type: "number",
                  outlined: "",
                  dense: "",
                  rules: [_vm.rules.value],
                },
                on: {
                  input: function ($event) {
                    return _vm.onInput(1)
                  },
                },
                model: {
                  value: _vm.max[0],
                  callback: function ($$v) {
                    _vm.$set(_vm.max, 0, $$v)
                  },
                  expression: "max[0]",
                },
              }),
              _c("v-card", { staticClass: "ma-1", attrs: { elevation: "0" } }, [
                _vm._v("."),
              ]),
              _c("v-text-field", {
                attrs: {
                  type: "number",
                  outlined: "",
                  dense: "",
                  rules: [_vm.rules.value],
                },
                on: {
                  input: function ($event) {
                    return _vm.onInput(1)
                  },
                },
                model: {
                  value: _vm.max[1],
                  callback: function ($$v) {
                    _vm.$set(_vm.max, 1, $$v)
                  },
                  expression: "max[1]",
                },
              }),
              _c("v-card", { staticClass: "ma-1", attrs: { elevation: "0" } }, [
                _vm._v("."),
              ]),
              _c("v-text-field", {
                attrs: {
                  type: "number",
                  outlined: "",
                  dense: "",
                  rules: [_vm.rules.value],
                },
                on: {
                  input: function ($event) {
                    return _vm.onInput(1)
                  },
                },
                model: {
                  value: _vm.max[2],
                  callback: function ($$v) {
                    _vm.$set(_vm.max, 2, $$v)
                  },
                  expression: "max[2]",
                },
              }),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ma-2",
                  attrs: { color: "primary" },
                  on: { click: _vm.onPressUpdate },
                },
                [_vm._v("UPDATE ")]
              ),
              _c("v-spacer"),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }